module.exports = __webpack_public_path__ + "img/dsci0035.929597df.jpg";